module.exports = (doc) => Promise.all(doc);
